import * as React from 'react';
import { usePanelRef, type Layout, type LayoutChangedMeta } from 'react-resizable-panels';

type UseDragShutPaneOptions = Readonly<{
  panelId: string;
  onDragShut: () => void;
  reopenSize: string;
}>;

export function useDragShutPane({ panelId, onDragShut, reopenSize }: UseDragShutPaneOptions) {
  const panelRef = usePanelRef();

  const onLayoutChanged = React.useCallback(
    (layout: Layout, meta: LayoutChangedMeta) => {
      if (layout[panelId] !== 0) return;
      if (meta.isUserInteraction) {
        onDragShut();
        return;
      }
      // The Group remounts a reopened pane at its cached collapsed size, so restore its default.
      panelRef.current?.resize(reopenSize);
    },
    [onDragShut, panelId, panelRef, reopenSize],
  );

  return { panelRef, onLayoutChanged };
}
